import { useQuery } from '@tanstack/react-query';
import { ClinicInfo } from '@companion-professional/dctypes';
import { getUserClinics } from '../lib/api';

// useUserClinics is a custom hook that fetches the all the clinics that the user has access to.
export const useUserClinics = () => {
  const {
    isPending,
    error,
    data: userClinics
  } = useQuery<ClinicInfo[]>({
    queryKey: ['user-clinics'],
    queryFn: () => getUserClinics()
  });

  return {
    isPending,
    error,
    userClinics
  };
};
